module.exports = __webpack_public_path__ + "static/media/31JFA8.f8dd9647.jpg";